import { Container, Flex } from "@radix-ui/themes";
import { ErrorBoundary } from "@sentry/react";
import { PropsWithChildren, Suspense } from "react";
import { RequiresAuthenticationIf } from "../authentication/core/components/requires-authentication-if.component";
import { FullSpinner } from "../shared/components/full-spinner";
import { NotFoundOrIntermittentError } from "../shared/components/not-found-or-intermittent-error";
import { UnitHeader } from "./components/unit-header.component";
import { useUnit } from "./hooks/use-unit";

const UnitRootContent: React.FC<PropsWithChildren> = ({ children }) => {
  const unit = useUnit();

  return (
    <Flex gap="4" direction="column" align="center">
      <UnitHeader />

      <RequiresAuthenticationIf
        requiresAuthentication={unit.stationRequiresLogin}
        allowedEmailDomains={unit.allowedEmailDomains}
        stationSlug={unit.stationSlug}
      >
        <Suspense fallback={<FullSpinner />}>{children}</Suspense>
      </RequiresAuthenticationIf>
    </Flex>
  );
};

export const UnitRoot: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Container size="1" p="2">
      <ErrorBoundary fallback={<NotFoundOrIntermittentError />}>
        <Suspense fallback={<FullSpinner />}>
          <UnitRootContent>{children}</UnitRootContent>
        </Suspense>
      </ErrorBoundary>
    </Container>
  );
};
